import $ from 'jquery';


class DynamicDiv {

    constructor(){
       this.events();
    }

    events(){
        $('.tabHeader').on('click', function () {
            if(!$(this).hasClass('active')){
                $(this).addClass('active').siblings().removeClass('active');
                $(this).attr('aria-selected', true).siblings().attr('aria-selected', false);
            }
            
            $($(this).data('target')).show().siblings().hide();
        });

    }






}

export default DynamicDiv;